var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('div',{class:{ '__loading-overlay': true,  '__visible': _vm.loading}},[(_vm.loading)?_c('component-loader'):_vm._e()],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }